import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import ActionButton from "../components/ActionButton";
import TextField from "@material-ui/core/TextField";
import axios from "../AxiosClient";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { setApplicationProperties } from "../redux/actions/universalActions.js";
import { useSnackbar } from "notistack";

function PasswordRequirementsDialog(props) {
  const { t } = useTranslation();
  const [saving, setSaving] = useState(false);
  const [useCapitals, setUseCapitals] = useState(false);
  const [useNumbers, setUseNumbers] = useState(false);
  const [useSpecialCharacters, setUseSpecialCharacters] = useState(false);
  const [minimumCharacters, setMinimumCharacters] = useState(8);
  const [error, setError] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const properties = useSelector((state) => ({
    ...state.setting.applicationProperties,
  }));

  useEffect(
    () => {
      let requirements = JSON.parse(
        properties["administration.useradmin.passwordstrengthrequirements"]
      );
      setUseCapitals(requirements.useCapitals);
      setUseNumbers(requirements.useNumbers);
      setUseSpecialCharacters(requirements.useSpecialCharacters);
      setMinimumCharacters(requirements.minimumCharacters);
      // }
    },
    [props.organization]
  );

  const save = () => {
    let passwordStrengthRequirementsObject = {
      useCapitals: useCapitals,
      useNumbers: useNumbers,
      useSpecialCharacters: useSpecialCharacters,
      minimumCharacters: minimumCharacters,
    };
    setSaving(true);
    dispatch(
      setApplicationProperties({
        ["administration.useradmin.passwordstrengthrequirements"]: JSON.stringify(
          passwordStrengthRequirementsObject
        ),
      })
    );
    axios
      .patch("/application-property/", {
        ["administration.useradmin.passwordstrengthrequirements"]: JSON.stringify(
          passwordStrengthRequirementsObject
        ),
      })
      .then(() => {
        enqueueSnackbar(t("properties_updated_snackbar"), {
          variant: "success",
        });
        setSaving(false);
        props.onClose();
      })
      .catch((err) => {
        enqueueSnackbar(t("properties_updated_error_snackbar"), {
          variant: "error",
        });
        setSaving(false);
      });
  };

  const handleCapitalsChange = (e) => {
    setUseCapitals(e.target.checked);
  };

  const handleSpecialCharactersChange = (e) => {
    setUseSpecialCharacters(e.target.checked);
  };

  const handleNumbersChange = (e) => {
    setUseNumbers(e.target.checked);
  };

  const handleMinCharactersChange = (e) => {
    setMinimumCharacters(e.target.value);
  };

  const checkForErrors = () => {
    if (minimumCharacters === 0 || minimumCharacters === null) {
      setError(true);
      return true;
    } else {
      setError(false);
      return false;
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        {t("change_password_strength_requirements")}
      </DialogTitle>
      <DialogContent>
        <TextField
          id="min-characters"
          error={error}
          fullWidth
          type="number"
          onChange={handleMinCharactersChange}
          value={minimumCharacters}
          label={t("select_minimum_amount_of_characters")}
        />
        <FormControlLabel
          id="require-capitals"
          control={
            <Checkbox checked={useCapitals} onChange={handleCapitalsChange} />
          }
          label={t("require_captial_letters")}
        />
        <FormControlLabel
          id="require-numbers"
          control={
            <Checkbox checked={useNumbers} onChange={handleNumbersChange} />
          }
          label={t("require_numbers")}
        />
        <FormControlLabel
          id="require-special-chars"
          control={
            <Checkbox
              checked={useSpecialCharacters}
              onChange={handleSpecialCharactersChange}
            />
          }
          label={t("require_special_characters")}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          {t("global_cancel")}
        </Button>
        <ActionButton
          loading={saving}
          disabled={error}
          onClick={save}
          id="save-password-requirements"
          color="primary"
        >
          {t("global_save")}
        </ActionButton>
      </DialogActions>
    </Dialog>
  );
}

export default PasswordRequirementsDialog;
